<template>
	<div class="component-section" @click="handleClick">
		<h3 class="section-title">Buttons</h3>
		<div class="buttons-container">
			<Button label="Primary" severity="primary" />
			<Button label="Secondary" severity="secondary" />
			<Button label="Success" severity="success" />
			<Button label="Info" severity="info" />
			<Button label="Warning" severity="warn" />
			<Button label="Danger" severity="danger" />
		</div>
		<div class="buttons-container mt-3">
			<Button label="Outlined Primary" variant="outlined" severity="primary" />
			<Button label="Outlined Secondary" variant="outlined" severity="secondary" />
			<Button label="Text Primary" variant="text" severity="primary" />
			<Button label="Text Secondary" variant="text" severity="secondary" />
		</div>
	</div>
</template>

<script setup lang="ts">
import Button from "primevue/button"

const emit = defineEmits<{
	(e: "elementClick", event: MouseEvent): void
}>()

const handleClick = (event: MouseEvent) => {
	emit("elementClick", event)
}
</script>

<style lang="scss" scoped>
.component-section {
	background: white;
	border-radius: 8px;
	padding: 1.5rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-bottom: 1rem;
}

.section-title {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 1rem;
	color: #374151;
	border-bottom: 2px solid #e5e7eb;
	padding-bottom: 0.5rem;
}

.buttons-container {
	display: flex;
	gap: 0.75rem;
	flex-wrap: wrap;
	align-items: center;
}

.mt-3 {
	margin-top: 1rem;
}
</style>
